import React, { useCallback, useState } from 'react';
import { ChevronRightIcon, FileTextIcon } from 'lucide-react';
import { TreatmentDrawer } from './treatment/TreatmentDrawer';
import type { Treatment } from '../types/care';
interface TreatmentListProps {
  treatments: Treatment[];
}
export function TreatmentList({
  treatments
}: TreatmentListProps) {
  const [active, setActive] = useState<Treatment | null>(null);
  const close = useCallback(() => setActive(null), []);
  return <>
      <ul className="divide-y divide-line overflow-hidden rounded-2xl border border-line bg-white" data-id="element-372" data-mp="2v54wd5fpbpeb">
        {treatments.map(t => <li key={t.slug} data-id="element-373" data-mp="2q73egnu0hw4f">
            <button type="button" onClick={() => setActive(t)} className="group flex w-full items-center gap-4 px-5 py-4 text-left transition-colors duration-150 hover:bg-surface" data-id="element-374" data-mp="2q6agab94cexw">
              <span className="min-w-0 flex-1" data-id="element-375" data-mp="jfko50cdaxyq">
                <span className="block font-medium text-ink group-hover:text-primary" data-id="element-376" data-mp="jgvriz1wi3pb">{t.name}</span>
                <span className="mt-0.5 block truncate text-sm text-muted" data-id="element-377" data-mp="3kl3iyze7ykts">{t.summary}</span>
              </span>
              {t.pdf && <FileTextIcon className="hidden h-4 w-4 shrink-0 text-muted sm:block" aria-label="Met patiëntenfolder" data-id="element-378" data-mp="3aoidye2799py" />}
              <ChevronRightIcon className="h-5 w-5 shrink-0 text-primary" aria-hidden="true" data-id="element-379" data-mp="3fmscmyn4usgb" />
            </button>
          </li>)}
      </ul>
      <TreatmentDrawer treatment={active} onClose={close} data-id="element-380" data-mp="79v0apv8t1w5" />
    </>;
}